<template>
	<v-container id="skills">
		<v-row>
			<v-col>
				<h2
        style="font-family: esquare;font-size: 2em; color: white; font-variant: small-caps;">
					Skills &amp; Experience
				</h2>
				<p class="overline grey--text">
					i'm a full stack developer with a front end heavy skill set<span class="period">.</span>
				</p>
				<p class="overline grey--text">
					the tech stack i currently favor is a vue<span class="period">.</span>js front end, node<span class="period">.</span>js back end, and a nosql database deployed using serverless architecture (firebase)<span class="period">.</span>
				</p>
				<p class="overline grey--text">
					experience working with a variety of content management systems, i enjoy building custom plugins, features, animations, and interactive layouts<span class="period">.</span>
				</p>
				<p class="overline grey--text">
					i've worked with a large variety of technologies and enjoy finding the right tool for the job<span class="period">.</span>
				</p>
				<!-- <ul>
					<li>
						Squarespace
					</li>
					<li>
						Webflow
					</li>
					<li>
						BabelJS
					</li>
					<li>
						lodash
					</li>
					<li>
						RESTful API
					</li>
					<li>
						JavaScript
					</li>
					<li>
						Vue CLI
					</li>
					<li>
						Vue<span class="period">.</span>js
					</li>
					<li>
						Angular<span class="period">.</span>js
					</li>
					<li>
						Firebase
					</li>
					<li>
						Google Analytics
					</li>
					<li>
						Wordpress
					</li>
					<li>
						Node<span class="period">.</span>js
					</li>
					<li>
						Serverless Architecture
					</li>
					<li>
						Data Mining
					</li>
					<li>
						JSON
					</li>
					<li>
						jQuery
					</li>
					<li>
						SQL
					</li>
					<li>
						noSQL
					</li>
					<li>
						HTML5
					</li>
					<li>
						Animation
					</li>
					<li>
						CSS
					</li>
					<li>
						Stripe API
					</li>
					<li>
						Git
					</li>
					<li>
						Ecommerce
					</li>
					<li>
						XML
					</li>
					<li>
						three<span class="period">.</span>js
					</li>
					<li>
						anime<span class="period">.</span>js
					</li>
					<li>
						Vuetify
					</li>
				</ul> -->
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	data() {
    return {}
	},
	methods: {},
	mounted() {
		window.scrollTo(0,0)
	}
}
</script>

<style scoped>

</style>